<template>
    <div>
        <div class="my-6 body-2 primary--text">(*)Required field</div>
        <form ref="contact" class="my-6">
            <v-row no-gutters>
                <v-col cols="6">
                    <label>
                        <span class="field-label">Name<span class="primary--text">*</span></span>
                        <v-text-field v-model="name" outlined dense></v-text-field>
                    </label>
                    <label>
                        <span class="field-label">Email Address<span class="primary--text">*</span></span>
                        <v-text-field v-model="email" outlined dense></v-text-field>
                    </label>
                    <label>
                        <span class="field-label">Organization</span>
                        <v-text-field v-model="organization" outlined dense></v-text-field>
                    </label>
                    <div v-if="!standard">
                        <label>
                            <span class="field-label">Subject<span class="primary--text">*</span></span>
                            <v-select v-model="subject" :items="subjects" outlined dense single-line placeholder="What's the nature of your message?"></v-select>
                        </label>
                    </div>
                </v-col>
            </v-row>
            <v-row no-gutters>
                <v-col cols="12">
                    <label>
                        <span class="field-label">Message<span class="primary--text">*</span></span>
                        <v-textarea v-model="message" outlined dense></v-textarea>
                    </label>
                </v-col>
            </v-row>
            <v-btn tile large color="primary" @click="submit()" :disabled="!canSubmit">Submit</v-btn>
            <v-fade-transition>
                <span class="primary--text ml-3" v-if="feedback">{{ feedback }}</span>
            </v-fade-transition>
        </form>
    </div>
</template>

<script>
    import isEmail from 'validator/lib/isEmail';

    export default {
        data: () => ({
            name: '',
            email: '',
            organization: '',
            subject: '',
            message: '',
            feedback: ''
        }),
        props: {
            standard: {
                type: Object,
                default: null
            }
        },
        computed: {
            subjects() {
                return ['New standard or area of need for the portal', 'Correction to an existing standard or area of need', 'Comment and/or feedback on a standard or area of need', 'Portal feedback and/or suggestion', 'Other'];
            },
            canSubmit() {
                return this.name && this.email && isEmail(this.email) && this.subject && this.message;
            }
        },
        methods: {
            showFeedback(feedback, success) {
                this.feedback = feedback;
                setTimeout(() => {
                    this.feedback = '';
                    this.$emit('complete', success);
                }, 5000);
            },
            reset() {
                for (const prop in this.$data) {
                    this.$data[prop] = '';
                }
                if (this.standard) {
                    this.subject = 'Feedback or updates on this item';
                }
            },
            submit() {
                return this.$api
                    .post('/contact', Object.assign(this.$data, this.$props))
                    .then(() => {
                        this.reset();
                        this.showFeedback('Thank you for your input!', true);
                    })
                    .catch(() => {
                        this.showFeedback('We were unable to process your submission, please try again.', false);
                    });
            }
        }
    };
</script>

<style lang="scss" scoped>
    .field-label {
        font-family: $heading-font-family;
        text-transform: uppercase;
    }
</style>
